import React from 'react';
import Typography from '@material-ui/core/Typography';
import Layout from '../../../Components/layouts';
import commonStyles from '../../../theme/commonStyles';
import ProjectSearch from './ProjectSearch';

const ProjectsPage = () => {
  const commonClasses = commonStyles();
  const [initialLoading, setInitialLoading] = React.useState(true);
  return (
    <Layout>
      <main>
        <div className={initialLoading ? undefined : commonClasses.contentWrapper}>
          {!initialLoading ? <Typography variant="h4" className={commonClasses.pageTitle}>Projects</Typography> : null}
          <ProjectSearch embedded syncUrl onInitialLoadingChange={setInitialLoading} />
        </div>
      </main>
    </Layout>
  );
};

export default ProjectsPage;
